import { ReportOutput } from '@eppendorf/vnls-reporting-service-utils';
import { type SyntheticEvent, useCallback, useState } from 'react';

import { trackPendoEvent } from '$shared/tracking/trackPendoEvent';

export interface DeleteDialogState {
  isDeleteReportDialogOpen: boolean;
  selectedReport: ReportOutput | undefined;
  setIsDeleteReportDialogOpen: (open: boolean) => void;
  handleDeleteReport: (event: SyntheticEvent, report: ReportOutput) => void;
}

export function useDeleteDialog(): DeleteDialogState {
  const [isDeleteReportDialogOpen, setIsDeleteReportDialogOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState<ReportOutput | undefined>(
    undefined,
  );

  const handleDeleteReport = useCallback(
    (event: SyntheticEvent, report: ReportOutput) => {
      // Manual Pendo tracking before stopping propagation
      trackPendoEvent('delete', { reportId: report.id });

      event.stopPropagation();
      setSelectedReport(report);
      setIsDeleteReportDialogOpen(true);
    },
    [],
  );

  return {
    isDeleteReportDialogOpen,
    selectedReport,
    setIsDeleteReportDialogOpen,
    handleDeleteReport,
  };
}
